import { useEffect, useMemo } from "react";
import { DataGrid } from "@mui/x-data-grid";

const PatientMapRosterTableOpport = ({
  data = [],
  searchTerm = "",
  loading,
  total,
  page,
  pageSize,
  setPage,
  setPageSize,
  onSelectPatient
}) => {
  const rows = useMemo(() => {
    return data;
  }, [data, searchTerm]);
  const columns = useMemo(() => [
    { field: "TimeStamp", headerName: "TimeStamp", flex: 3, filterable: false },
    { field: "MemberName", headerName: "Member Name", flex: 3, filterable: false },
    { field: "MemberPhoneNumber", headerName: "Member Phone Number", flex: 3, filterable: false },
    { field: "MemberMobileNumber", headerName: "Member Mobile Number", flex: 3, filterable: false },
    { field: "Location", headerName: "Location", flex: 3, filterable: false },
    { field: "PcpName", headerName: "Pcp Name", flex: 3, filterable: false },
    { field: "DateOfService", headerName: "Date Of Service", flex: 3, filterable: false },
    { field: "Comments", headerName: "Comments", flex: 3, filterable: false },
    { field: "Staff", headerName: "Staff", flex: 3, filterable: false },
  ], [onSelectPatient]);


  return (
    <div style={{ width: "100%", overflowX: "auto" }}>
      <div style={{ minWidth: "1500px" }}>
        <DataGrid
          getRowId={(row) => `${row.PostVisitID}`}
          rows={rows}
          columns={columns}
          rowCount={total}
          paginationMode="server"
          paginationModel={{ page, pageSize }}
          onPaginationModelChange={({ page, pageSize }) => {
            setPage(page);
            setPageSize(pageSize);
          }}
          pageSizeOptions={[10, 25, 50, 100]}
          disableColumnFilter
          disableColumnSelector
          loading={loading}
          onRowClick={(params) => onSelectPatient(params.row)}
          sx={{
            border: '1px solid #ccc',
            '& .MuiDataGrid-footerContainer': {
              justifyContent: 'flex-start',
            },
            '& .MuiDataGrid-columnHeader': {
              backgroundColor: '#607d8b',
              color: '#fff',
              fontWeight: 'bold',
            },
            '& .MuiDataGrid-row': {
              backgroundColor: '#fff', 
            },
            '& .MuiDataGrid-row:nth-of-type(even)': {
              backgroundColor: '#f5f5f5', 
            },
            '& .MuiDataGrid-row:hover': {
              backgroundColor: '#e3f2fd',
            },
            '& .MuiDataGrid-cell': {
              borderBottom: '1px solid #eee',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            },
          }}
          density="compact"
          style={{ height: 600 }}
        />
      </div>
    </div>
  );
};

export default PatientMapRosterTableOpport;
